import React from 'react';
import {observer} from 'mobx-react';
import configurationStore from '@lib/store/configuration';
import EditorConfigurationStatusDropdown from './EditorConfigurationStatusDropdown';
import TechnicalInformationCardIssuesList from './TechnicalInformationCardIssuesList';
import HelpSystemInformation from '../common/HelpSystemInformation';

const ConfigurationEditorTechnicalInformationCard = observer(
    class ConfigurationEditorTechnicalInformationCard extends React.Component {
        onStatusDropdownItemClick = item => {
            configurationStore.formModel.generalInformation.status.value = item.id
            this.props.onFormModelChange()
            configurationStore.setDirty(true);
        }

        render() {
            const {discountedTotal, currency} = this.props.model

            return (
                <div className="card" style={{minHeight: '209px'}}>
                    <div className="card-title">
                        <div className="title">
                            <span>{__('Technical information')}</span>
                            <HelpSystemInformation text={this.props.helpInfo}/>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row row-no-outer-gutter">
                            <div className="column-6 column-xs-12">
                                <div className="configuration-editor-info-card-field">
                                    <div className="configuration-editor-info-card-field-label">{__('Product')}</div>
                                    <div
                                        className="configuration-editor-info-card-field-value">{this.renderProductName()}</div>
                                </div>

                                <div className="configuration-editor-info-card-field">
                                    <div className="configuration-editor-info-card-field-label">{__('Status')}</div>
                                    <div className="configuration-editor-info-card-field-value">
                                        {this.renderStatusDropdown()}
                                    </div>
                                </div>
                            </div>

                            <div className="column-6 column-xs-12 second-technical-fields-column">
                                <div className="configuration-editor-info-card-field">
                                    <div className="configuration-editor-info-card-field-label">{__('Setup')}</div>
                                    <div className="configuration-editor-info-card-field-value">
                                        {configurationStore.formModel.generalInformation.setup.value}
                                    </div>
                                </div>

                                {discountedTotal.visible && <div className="configuration-editor-info-card-field">
                                    <div className="configuration-editor-info-card-field-label">{__('Total PPL')}</div>
                                    <div className="configuration-editor-info-card-field-value">
                                        {discountedTotal.value} {currency}
                                    </div>
                                </div>}
                            </div>
                        </div>

                        <div>
                            <div
                                className="configuration-editor-info-card-field configuration-editor-info-card-issues-field">
                                <div className="configuration-editor-info-card-field-label">{__('Issues')}</div>
                                <div className="configuration-editor-info-card-field-value">
                                    <TechnicalInformationCardIssuesList issues={configurationStore.issues}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        renderProductName() {
            let type = configurationStore.getProductType()
            return type ? type.text : ''
        }

        renderStatusDropdown() {
            let editableMode = configurationStore.editableMode;
            let items = configurationStore.formModel.generalInformation.status.items.map(x => {
                let color = ['#71b850', '#7088ba', '#ff4b5c'][x.value];

                return {
                    id: x.value,
                    color: color,
                    label: x.text
                }
            })
            let currentStatusItem = items.find(x => x.id === configurationStore.formModel.generalInformation.status.value);
            return (
                <div className="configuration-status-dropdown">
                    <div className="dropdown-button-body">
                        <div className="dot-color" style={{backgroundColor: currentStatusItem.color}}></div>
                        <div>{currentStatusItem.label}</div>
                    </div>
                </div>
            )
            // if (!editableMode) {

            // }

            return (
                <EditorConfigurationStatusDropdown items={items} currentItem={currentStatusItem}
                                                   onItemClick={this.onStatusDropdownItemClick}/>
            )
        }

        getProductNameById(id) {
            switch (id) {
                case 'product-type-maxicompact':
                    return 'Maxi Compact';

                case 'product-type-2':
                    return 'Maxi C1S/C2';
            }

            return null
        }
    }
)

export default ConfigurationEditorTechnicalInformationCard